import { useEffect, useState } from 'react';
import { useMoralis } from 'react-moralis';
import { PresaleABI } from '../../../data/ABI';
import { inChainId } from '../../../data/chainId';
import { PresaleContract } from '../../../utility/contractAddress';
import { weekday } from '../../../utility/weekday';
import { BtnLoading } from '../../atoms';
import { toast, ToastContainer } from 'react-toastify';
import './IdoCompnent.scss';
const IdoCompnent = ({ detail, timer, salingState, fundGoal, soldToken }) => {
  const STARTTIME = new Date(detail.startTime);
  const startDate = `${weekday[STARTTIME.getDay()]} ${STARTTIME.getDate()} - ${STARTTIME.getMonth() + 1} - ${STARTTIME.getFullYear()}`;
  const [countContribute, setCountContribute] = useState()
  const [detailUser, setDetailUser] = useState({})
  const [loading, setLoading] = useState(false)
  const [hashContribute, setHashContribute] = useState('')
  // handle form
  const inputContribute = (val) => {
    // if(parseInt(val) <= detail.maxContribute && parseInt(val) >= detail.minContribute){
    //   setCountContribute(val)
    // }
    setCountContribute(val)
  }

  const { user, Moralis, authenticate } = useMoralis()
  const getUserInfo = async () => {
    const web3 = await Moralis.enableWeb3();
    if (user) {
      const walletAddress = await user.get("ethAddress");
      const chainIdDec = await web3.eth.getChainId();
      if (parseInt(inChainId) === parseInt(chainIdDec)) {
        let stabcontract = new web3.eth.Contract(PresaleABI, PresaleContract);
        // let stabcontract = new web3.eth.Contract(PresaleABI, detail.tokenAddress);
        const infouser = await stabcontract.methods.fundersProperty(walletAddress).call();
        setDetailUser(infouser)
      } else {
        console.log("Connect to BSC Network!");
      }
    }
  }
  useEffect(() => {
    getUserInfo()
    console.log(detail.tokenAddress)
  }, [])
  const handleContribute = async () => {
    if (!user) {
      authenticate({ signingMessage: "signing in IDM Launchpad" })
      return;
    }
    try {
      setLoading(true)
      const web3 = await Moralis.enableWeb3();
      const chainIdDec = await web3.eth.getChainId();
      const walletAddress = await user.get("ethAddress");
      if (parseInt(inChainId) === parseInt(chainIdDec)) {
        let stabcontract = new web3.eth.Contract(PresaleABI, PresaleContract);
        // let stabcontract = new web3.eth.Contract(PresaleABI, detail.tokenAddress);
        const amountContribute = (countContribute * 10 ** 18).toLocaleString('fullwide', { useGrouping: false });
        stabcontract.methods.Contribute(walletAddress).send(
          {
            from: walletAddress,
            value: amountContribute,
          },
          function (err, res) {
            if (err) {
              console.log("Error", err);
              setLoading(false)
              return;
            }
            if (res) {
              toast.success("Contribute successfull!")
              setHashContribute(res)
              setCountContribute('')
              setLoading(false)
            }
          }
        );
      } else {
        setLoading(false)
      }
    } catch (error) {
      console.log(error.message)
      setLoading(false)
    }
  }
  return (
    <div className="ido">
      <div className="container">
        <div className="wrapper">
          <div className="row">
            <div className="col-lg-7">
              <div className="detail-info">
                <div className="brand">
                  <div className="logo-wrapper">
                    <img className="img" src={detail.logoList} alt="logo" />
                  </div>
                  <span className="name">{detail.tokenName}</span>
                </div>
                <div className="desc-wrapper">
                  <p className="desc">{detail.desc}</p>
                </div>
              </div>
              <div className="card-info">
                <div className="card-info-item">
                  <div className="title">Round Type</div>
                  <div className="val">Private Sale</div>
                </div>
                <div className="card-info-item">
                  <div className="title">Start Date</div>
                  <div className="val">{startDate}</div>
                </div>
                <div className="card-info-item">
                  <div className="title">Token Price</div>
                  <div className="val">{(1 / detail.presaleRate).toFixed(9)} BNB</div>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="contribute-wrapper">
                <div className="form-cont">
                  <div className="inProgress">
                    <div className="name-status">
                      <span className="name">{salingState}</span>
                      <small>Time Left</small>
                    </div>
                  </div>
                  <div className="info-prog">
                    <div className="item-prog">
                      <div className="val-prog" style={{ width: `${soldToken / fundGoal * 100}%` }} />
                    </div>
                    <div className="val-info">
                      <span className='perc'>{(soldToken / fundGoal * 100).toFixed(2)} %</span>
                      <span className="val">
                        {soldToken} / {fundGoal}
                      </span>
                    </div>
                  </div>
                  <div className="input-wrapper">
                    <input
                      type="number"
                      max={detail.maxContribute}
                      value={countContribute}
                      onChange={(e) => inputContribute(e.target.value)}
                      placeholder='1 BNB = 200 IDM'
                    />
                  </div>
                  <div className="min-max text-center my-3">
                    Min : {detail.minContribute} | Max : {detail.maxContribute}
                  </div>
                  <div className="btnWrapper text-center">
                    {
                      loading ? <BtnLoading /> : <button onClick={handleContribute} className="btnCont">Contribute</button>
                    }
                  </div>
                  {
                    hashContribute && (
                      <small className='text-center text-primary d-block mt-3'>
                        <a href={`https://testnet.bscscan.com/tx/${hashContribute}`} target="_blank" rel="noopener noreferrer">
                          Check Transaction
                        </a>
                      </small>
                    )
                  }

                </div>
              </div>
              <div className="bottom-info">
                <div className="presale-end text-center my-4">
                  <span>Presale Ends in :</span>
                  <div className="timer-wrapper">
                    <div className="t">{timer.days}</div>
                    <div className="t">{timer.hours}</div>
                    <div className="t">{timer.minutes}</div>
                    <div className="t">{timer.seconds}</div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-6">
                    <div className="card-count-cont">
                      <span className="text-center">Your contribution amount</span>
                      <span className="text-center">{detailUser.reservedETH ? detailUser.reservedETH / 10 ** 18 : 0} BNB</span>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="card-count-cont">
                      <span className="text-center">Your reserved token</span>
                      <span className="text-center">{detailUser.reservedETH ? detailUser.reservedToken / 10 ** 18 : 0} {detail.symbol}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
    </div>
  )
}

export default IdoCompnent
